import ctl from '@netlify/classnames-template-literals';

const indicatorBaseStyle = ctl(`
  w-2 
  h-2
  rounded-[50%]
`);

const activeIndicatorStyles = ctl(`
  ${indicatorBaseStyle}
  bg-green-ncs
`);

const indicatorStyles = ctl(`
  ${indicatorBaseStyle}
  bg-american-pink
`);

export default {
  activeIndicatorStyles,
  indicatorStyles,
};
